import React, { useState, useEffect } from "react";
import { Card, CardBody, Row, Col } from "reactstrap";
import "./technologyCards.css";
import { useNavigate } from "react-router-dom";
// import StudentDetailsCard from "./StudentDetailsCard";

const TechnologiesCards = ({ course_id, technologies, course_name }) => {
  const [selectedTechnology, setSelectedTechnology] = useState(null);
  const navigate = useNavigate();

  console.log("Technologies received:", technologies);

  const colorGradients = [
    "linear-gradient(135deg, #36d1dc 0%, #5b86e5 100%)",
    "linear-gradient(135deg, #ff9966 0%, #ff5e62 100%)",
    "linear-gradient(135deg, #43cea2 0%, #185a9d 100%)",
    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    "linear-gradient(135deg, #ff6a00 0%, #ee0979 100%)",
  ];


  useEffect(() => {
    if (selectedTechnology) {
      navigate(`/add-zero-course-payment/${course_id}/${selectedTechnology.technology_id}`);
    }
  }, [selectedTechnology]);

  return (
    <React.Fragment>
      <div className="text-center mb-4 mt-4">
        <h2 className="fw-bold text-primary text-uppercase">
          Technologies for {course_name}
        </h2>
        <p className="text-muted mb-0">
          Click on a technology card below to get student Fee details.
        </p>
      </div>

      {/* Technologies Grid */}
      <Row className="g-4">
  {technologies.map((tech, index) => (
    <Col
      xl={3}
      lg={3}
      md={3}
      sm={6}
      xs={12}
      key={index}
      onClick={() => tech.status === 1 && setSelectedTechnology(tech)}
      style={{
        pointerEvents: tech.status === 0 ? "none" : "auto", // BLOCKS CLICK
      }}
    >
      <Card
        className={`tech-card border-0 ${tech.status === 0 ? "card-disabled" : ""}`}
        style={{
          background: colorGradients[index % colorGradients.length],
          color: "white",
          borderRadius: "10px",
          cursor: tech.status === 0 ? "not-allowed" : "pointer",
          display: "flex",
          justifyContent: "center",
          boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
          transition: "transform 0.3s ease, box-shadow 0.3s ease",
        }}
        onMouseEnter={(e) => {
          if (tech.status === 0) return;
          e.currentTarget.style.transform = "translateY(-6px)";
          e.currentTarget.style.boxShadow = "0 10px 25px rgba(0,0,0,0.25)";
        }}
        onMouseLeave={(e) => {
          if (tech.status === 0) return;
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 6px 18px rgba(0,0,0,0.15)";
        }}
      >
        <CardBody className="p-3">
          <div className="d-flex align-items-center justify-content-between">
            {/* Left Side - Icon */}
            <div
              style={{
                backgroundColor: "rgba(255,255,255,0.15)",
                borderRadius: "15px",
                padding: "8px",
                flexShrink: 0,
              }}
            >
              <img
                width={60}
                height={60}
                src={`${process.env.REACT_APP_BACKEND_IMAGE_URL}technology-icons/${tech.technology_icon}`}
                alt={tech.technology_name}
                style={{
                  borderRadius: "10px",
                  objectFit: "contain",
                }}
              />
            </div>

            {/* Right Side - Text */}
            <div className="ms-3 flex-grow-1">
              <h6
                className="fw-bold text-uppercase text-white mb-0"
                style={{
                  lineHeight: "1.3",
                  fontSize: "14px",
                  wordBreak: "break-word",
                }}
              >
                {tech.technology_name}
              </h6>

              <p className="text-white-50 mb-1 text-justify program-name">
                {tech.program_name}
              </p>

              <div className="text-right">
                {tech.status === 0 ? (
                  <span className="badge bg-danger">Inactive</span>
                ) : (
                  <span className="badge bg-success">Active</span>
                )}
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  ))}
</Row>

    </React.Fragment>
  );
};

export default TechnologiesCards;